import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RoutePath } from 'state/router';
import { AppState } from 'state/state.model';

const getCurrentRoutePathSelector = (state: AppState) => state.router.path;

export function useIsAnyRouteActive(...targetPaths: RoutePath[]): boolean {
  const currentPath = useSelector(getCurrentRoutePathSelector);
  return useMemo(() => targetPaths.includes(currentPath as RoutePath), [currentPath, targetPaths]);
}
